module.exports = __webpack_public_path__ + "media/price_bot/light-bulb-0d4a706a.svg";